<template>
  <div
    class="inline-block w-2 h-2 mr-1 rounded-full"
    :class="paymentStatusToColorMap[formattedStatus]"
  />
  {{ formattedStatus }}
</template>
<script setup lang="ts">
import { paymentStatusToColorMap } from '@/helpers/category_color_mapper';

type PaymentStatusType = keyof typeof paymentStatusToColorMap
defineProps<{
  formattedStatus: PaymentStatusType
}>();
</script>
